import * as store from '@attain-apps/fe/web/main/lib/store'

import * as constants from '../constants'
import type { Plugin } from '../plugin'
import { State } from '../state'

/** Clears joint-use state after target-scoped organization editing completes. */
export const resetOnEditingComplete = store.reducers.extra(
  (_feature: Plugin['feature'], plugin: Plugin) =>
    new store.reducers.ExtraReducer({
      on: [
        plugin.collection.plugins.editingPlugin.feature.actions.submit.success,
        plugin.collection.plugins.editingPlugin.feature.actions.discard.success,
      ],
      reduce: (state: State, action) => {
        const current = action.data.request.current
        return current !== true &&
          current?.target === constants.CURRENT_ENTITY_TARGET
          ? State.INITIAL
          : state
      },
    }),
)
